/* Así funciona · Cortina Blackout Jacquard con Aros (2216219)
   La sala de la tienda con la cortina REAL (sus 2 paneles recortados de la foto, en el mismo sitio en que están en la
   foto de ambiente). La clienta arrastra la cortina (o la barra) y los paneles corren por el riel: la tela real se
   recoge en pliegues (se comprime de lado y sus valles se oscurecen) y, al cerrarla, el cuarto se oscurece porque la
   tela tapa la luz de la ventana. Lo de detrás de la tela (la ventana real de la foto que sigue detrás, la pared y el
   riel) está armado con píxeles de la misma foto, sin IA (fondo_compuesto.py). Ficha: tela jacquard gruesa que ayuda a bloquear gran parte de la luz, 2 paneles de
   150 x 220 cm (cubren 300 x 220 cm), aros metálicos. Piezas: tiendas/nayhogar/funciona/cortina-blackout-jacquard-con-aros */
NHF.escena('cortina-blackout-jacquard-con-aros', function (E) {
  const D = /*DATOS*/{"caja":[230,80,1139,1376],"k":1.13786,"fondo":"fn-cortina-blackout-jacquard-con-aros-fondo.webp","paneles":{"izq":{"src":"fn-cortina-blackout-jacquard-con-aros-panel-izq.webp","x":230,"w":592,"paso":4,"lum":[0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.003,0.02,0.079,0.221,0.444,0.675,0.829,0.894,0.907,0.903,0.895,0.892,0.891,0.891,0.888,0.882,0.878,0.885,0.908,0.946,0.983,1.0,0.993,0.954,0.896,0.836,0.784,0.743,0.713,0.688,0.667,0.645,0.62,0.596,0.576,0.561,0.55,0.54,0.529,0.519,0.513,0.514,0.526,0.549,0.58,0.618,0.66,0.71,0.769,0.83,0.875,0.883,0.853,0.809,0.771,0.749,0.736,0.73,0.735,0.756,0.793,0.841,0.897,0.957,0.998,1.0,1.0,0.981,0.919,0.856,0.801,0.751,0.709,0.674,0.647,0.627,0.613,0.603,0.596,0.59,0.585,0.58,0.573,0.564,0.554,0.551,0.559,0.579,0.608,0.64,0.677,0.721,0.777,0.846,0.911,0.945,0.93,0.875,0.812,0.765,0.736,0.718,0.712,0.719,0.738,0.765,0.796,0.831,0.87,0.917,0.969,1.0,1.0,1.0,0.995,0.951,0.9,0.86,0.831,0.808,0.785,0.759,0.733,0.708,0.682,0.654,0.621,0.585,0.551,0.522,0.501,0.488,0.482,0.479,0.476,0.475,0.476,0.481,0.485],"tela":[54,591]},"der":{"src":"fn-cortina-blackout-jacquard-con-aros-panel-der.webp","x":822,"w":547,"paso":4,"lum":[0.656,0.706,0.775,0.808,0.78,0.712,0.65,0.623,0.634,0.671,0.72,0.769,0.812,0.848,0.883,0.92,0.957,0.989,1.0,0.999,0.975,0.935,0.891,0.85,0.814,0.783,0.76,0.743,0.722,0.693,0.657,0.621,0.59,0.565,0.542,0.519,0.501,0.494,0.501,0.522,0.55,0.581,0.615,0.662,0.729,0.808,0.872,0.89,0.857,0.798,0.743,0.704,0.682,0.68,0.699,0.739,0.792,0.853,0.916,0.974,1.0,1.0,0.992,0.939,0.873,0.81,0.756,0.715,0.684,0.66,0.641,0.622,0.603,0.584,0.565,0.546,0.529,0.516,0.514,0.523,0.542,0.568,0.599,0.634,0.675,0.725,0.782,0.838,0.874,0.873,0.836,0.779,0.726,0.691,0.677,0.68,0.695,0.721,0.756,0.799,0.845,0.894,0.95,0.997,1.0,1.0,0.986,0.926,0.872,0.836,0.811,0.787,0.76,0.728,0.695,0.667,0.647,0.633,0.62,0.61,0.604,0.598,0.59,0.582,0.573,0.538,0.444,0.29,0.13,0.023,0.0,0.0,0.0,0.0,0.0,0.0,0.0],"tela":[0,509]}},"ventana":[560,204,898,688]}/*FIN*/;
  const S = E.lienzo({ w: 1600, h: 1600, vista: [120, 30, 1360, 1300], vistaMovil: [170, 30, 1260, 1440] });
  E.titulo('Ciérrala y [apaga el día].', 'Arrastra la cortina por su riel: al cerrarla, el cuarto se oscurece.');
  S.cargando(true);

  const fondo = S.img(D.fondo, null, { z: 1, alt: 'Sala con la cortina jacquard abierta' });
  const sol = S.div([0, 0, 1600, 1600], { z: 2, opacidad: 0 });
  sol.style.background = 'radial-gradient(52% 42% at 63% 36%, rgba(255,246,228,.6), rgba(255,246,228,0) 72%), radial-gradient(48% 22% at 58% 96%, rgba(255,240,215,.45), rgba(255,240,215,0) 70%)';
  sol.style.mixBlendMode = 'soft-light';
  const C = D.caja;
  const tela = S.canvas([C[0] - 10, C[1] - 10, C[2] + 20, C[3] + 20], { z: 3, res: Math.min(0.75, (window.devicePixelRatio || 1) * 0.42) });
  const sombra = S.div([0, 0, 1600, 1600], { z: 4, opacidad: 0 });
  sombra.style.background = 'linear-gradient(180deg,#14161c,#1b1d24)'; sombra.style.mixBlendMode = 'multiply';
  let I = {};
  E.cargar([D.fondo, D.paneles.izq.src, D.paneles.der.src]).then(r => { I.izq = r[1]; I.der = r[2]; S.cargando(false); pintar(); });

  /* ---------- estado: abierta (1) .. cerrada (0) ---------- */
  let abierto = 1, meta = 1, vistoCerrar = false;
  E.pasos(['Arrastra la cortina hacia el centro para cerrarla', 'Mira cómo se oscurece el cuarto', 'Ábrela otra vez']);
  E.paso(0);
  const rango = E.deslizador({ etiqueta: 'Cortina', min: 0, max: 100, valor: 0, formato: v => v < 4 ? 'Abierta' : v > 96 ? 'Cerrada' : Math.round(v) + ' %' }, v => { meta = 1 - v / 100; arrancar(); });
  const lect = E.lectura({ etiqueta: 'Luz en el cuarto' }); lect.poner('Día');
  lect.querySelector('.nhf-lectura__v').style.fontSize = 'clamp(26px,3vw,38px)';
  E.nota('2 paneles de 150 x 220 cm: cubren 300 x 220 cm. Tela jacquard gruesa con aros metálicos.');

  // cada panel real se dibuja en tiras verticales en un lienzo aparte; al recogerse se comprime hacia su lado y sus
  // valles (columnas oscuras de la foto) se oscurecen más, solo sobre la tela (source-atop): pliegues más hondos,
  // como una cortina de aros recogida
  const off = document.createElement('canvas');
  function panel(nombre, k) {
    const p = D.paneles[nombre], img = I[nombre]; if (!img) return;
    const ctx = tela.ctx, paso = p.paso, n = p.lum.length, hh = C[3];
    const ancla = nombre === 'izq' ? p.x + p.tela[0] : p.x + p.tela[1];
    const esc = 1 - 0.76 * k; // ancho que queda al abrirla del todo: ~24 %
    if (off.width !== tela.el.width) { off.width = tela.el.width; off.height = tela.el.height; }
    const o = off.getContext('2d');
    o.setTransform(1, 0, 0, 1, 0, 0); o.clearRect(0, 0, off.width, off.height);
    o.setTransform(tela.res, 0, 0, tela.res, -tela.caja[0] * tela.res, -tela.caja[1] * tela.res);
    const tira = i => { const sxa = p.x + i * paso, d0 = ancla + (sxa - ancla) * esc, d1 = ancla + (sxa + paso - ancla) * esc; return [Math.min(d0, d1), Math.abs(d1 - d0) + 0.6]; };
    for (let i = 0; i < n; i++) { const [x, w] = tira(i); o.drawImage(img, i * paso, 0, paso, img.height, x, C[1], w, hh); }
    if (k > 0.01) {
      o.globalCompositeOperation = 'source-atop';
      for (let i = 0; i < n; i++) {
        const L = p.lum[i], a = k * (0.5 * Math.pow(1 - L, 1.3) - 0.12 * L), [x, w] = tira(i);
        o.fillStyle = a >= 0 ? 'rgba(28,20,12,' + a.toFixed(3) + ')' : 'rgba(255,246,230,' + (-a).toFixed(3) + ')';
        o.fillRect(x, C[1], w, hh);
      }
      o.globalCompositeOperation = 'source-over';
    }
    ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(off, 0, 0); ctx.restore();
  }
  function pintar() {
    tela.limpiar();
    const k = abierto;
    panel('izq', k); panel('der', k);
    const cerrada = 1 - k;
    sombra.style.opacity = (cerrada * 0.62).toFixed(3);
    sol.style.opacity = (k * 0.9).toFixed(3);
    E.noche(cerrada > 0.7);
    lect.poner(cerrada > 0.92 ? 'Oscuro' : cerrada > 0.5 ? 'Penumbra' : cerrada > 0.15 ? 'Media luz' : 'Día');
    rango.poner(Math.round(cerrada * 100));
  }

  /* ---------- animación hacia la meta (la tela corre con un poco de inercia) ---------- */
  let corriendo = false;
  function arrancar() {
    if (corriendo) return; corriendo = true;
    let ult = performance.now();
    const paso = t => {
      const dt = Math.min(0.05, (t - ult) / 1000); ult = t;
      const d = meta - abierto;
      abierto += d * Math.min(1, dt * 9);
      if (Math.abs(d) < 0.002) abierto = meta;
      pintar();
      if (abierto !== meta) requestAnimationFrame(paso); else { corriendo = false; guia(); }
    };
    requestAnimationFrame(paso);
  }
  function guia() {
    if (abierto < 0.06) vistoCerrar = true;
    if (!vistoCerrar) { E.paso(abierto < 0.6 ? 1 : 0); S.pista('Arrastra la cortina hacia el centro', 'flechas'); return; }
    if (abierto > 0.9) { E.paso(3); S.pista(null); E.listo('Cerrada, el cuarto queda en penumbra aunque afuera haga sol: para dormir o ver televisión sin reflejos.', reiniciar); }
    else { E.paso(2); S.pista('Ahora ábrela otra vez', 'flechas'); }
  }
  function reiniciar() { E.noListo(); vistoCerrar = false; meta = 1; arrancar(); E.paso(0); }

  /* ---------- arrastrar la tela con el dedo (la orilla de cada panel sigue al dedo) ---------- */
  const zona = S.toque([C[0], C[1] + 60, C[2], C[3] - 60], { etiqueta: 'Cortina: arrástrala para abrirla o cerrarla' });
  zona.style.touchAction = 'pan-y'; zona.style.cursor = 'ew-resize';
  const centro = D.paneles.der.x, bordeI = D.paneles.izq.x + D.paneles.izq.tela[0], bordeD = D.paneles.der.x + D.paneles.der.tela[1];
  let agarre = null;
  zona.addEventListener('pointerdown', e => {
    const p = S.punto(e); S.el.classList.add('is-tocado');
    agarre = { lado: p.x < centro ? 'izq' : 'der', x0: p.x, a0: abierto };
    try { zona.setPointerCapture(e.pointerId); } catch (x) {}
  });
  zona.addEventListener('pointermove', e => {
    if (!agarre) return;
    const p = S.punto(e), dx = p.x - agarre.x0;
    const ancho = (agarre.lado === 'izq' ? centro - bordeI : bordeD - centro) * 0.76;
    const d = (agarre.lado === 'izq' ? -dx : dx) / ancho; // hacia afuera = abrir
    meta = E.clamp(agarre.a0 + d, 0, 1); arrancar();
  });
  const soltar = () => { agarre = null; };
  zona.addEventListener('pointerup', soltar); zona.addEventListener('pointercancel', soltar);

  pintar();
  S.pista('Arrastra la cortina hacia el centro', 'flechas');
});
